import { render, staticRenderFns } from "./RichTextEdit.vue?vue&type=template&id=3ca29a78&scoped=true&"
import script from "./RichTextEdit.vue?vue&type=script&lang=js&"
export * from "./RichTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEdit.vue?vue&type=style&index=0&id=3ca29a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca29a78",
  null
  
)

export default component.exports